<template>
  <div class="mt-2 flex overflow-hidden flex-grow">
    <div class="overflow-hidden flex flex-col pb-4 flex-grow bg-trader-gray mr-2">

      <!-- Go back -->
      <div class="w-full h-10">
        <CGoBack/>
      </div>

      <!-- Bearbeitung Weißer Hintergrund -->
      <div class="flex-grow overflow-hidden px-10 h-full flex text-center justify-center">

        <div class="overflow-auto bg-white rounded p-10 max-w-[1000px] flex-grow">

          <!-- Header -->
          <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl">API-Key Bearbeiten</span>
            </div>
          </div>

          <!-- Formular -->
          <div class="flex-grow flex flex-col space-y-4 overflow-auto">

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Name</span>
              <input
                  class="border p-2 rounded w-full"
                  required
                  v-model="name"
                  :class="{'border-red-500': showError && !this.name}"
                  data-ui="apikey-name"
                  placeholder="z.B. Production API Key">
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Beschreibung</span>
              <textarea
                  class="border p-2 rounded w-full"
                  v-model="description"
                  :class="{'border-red-500': showError && !this.description}"
                  data-ui="apikey-description"
                  placeholder="Beschreibung des API-Keys..."
                  rows="4">
              </textarea>
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Erstellt am</span>
              <input
                  class="border p-2 rounded w-full bg-gray-50"
                  :value="formatDate(createdAt)"
                  readonly>
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">API-Key</span>
              <input
                  class="border p-2 rounded w-full bg-gray-50 font-mono text-sm"
                  :value="key"
                  readonly>
            </div>

            <div class="flex space-x-2">
              <button
                  class="w-full rounded p-3 bg-primary hover:bg-trader-red hover:text-white transition duration-200 ease-in-out"
                  @click="deleteApiKey"
                  data-ui="delete-apikey-button">
                API-Key Löschen
              </button>
            </div>

            <button
                class="w-full rounded p-3 bg-primary hover:bg-trader-green hover:text-white transition duration-200 ease-in-out"
                @click="saveApiKey"
                data-ui="save-apikey-button">
              Speichern
            </button>


          </div>

        </div>
      </div>
    </div>

    <Sidebar />
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../../apolloClient";
import router from "@/router";
import Sidebar from "@/components/Administration/Sidebar.vue";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
import {query, mutation} from "@/graphql";

export default {
  components: {
    CGoBack,
    Sidebar,
    SuccessConfirmation
  },
  data() {
    return {
      apiKeyId: null,
      name: "",
      key: "",
      description: "",
      createdAt: null,
      lastUsedAt: null,
      showError: false,
      accordionIndex: 0,
    };
  },
  methods: {
    goBack() {
      router.push(`/administration/${this.accordionIndex}`);
    },

    async loadApiKey() {
      const [apiKeyDetails, error] = await query.getApiKey(this.apiKeyId);

      if (error == null && apiKeyDetails) {
        this.name = apiKeyDetails.name || '';
        this.description = apiKeyDetails.description || '';
        this.createdAt = apiKeyDetails.createdAt || null;
        this.lastUsedAt = apiKeyDetails.lastUsedAt || null;
        this.key = apiKeyDetails.key || '';
      } else {
        console.error("Fehler beim Laden des API-Keys:", error);
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Fehler",
          message: "Der API-Key konnte nicht geladen werden",
        });
      }
    },

    async saveApiKey() {
      if (!this.name || !this.description) {
        this.showError = true;
        return;
      }
      this.showError = false;

      const apiKeyData = {
        id: this.apiKeyId,
        name: this.name,
        description: this.description
      };

      const [result, err] = await mutation.updateApiKey(apiKeyData);

      if (err != null) {
        console.error(err);
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Fehler",
          message: "Der API-Key konnte nicht gespeichert werden",
        });
      } else {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "API-Key gespeichert",
          message: "Der API-Key wurde erfolgreich aktualisiert",
        });
      }
    },

    deleteApiKey() {
      eventBus.openConfirm({
        title: "API-Key löschen",
        message: "Möchten Sie diesen API-Key wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        onAccept: async () => {
          const [result, err] = await mutation.deleteApiKey(this.apiKeyId);

          if (err != null) {
            console.error(err);
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Fehler",
              message: "Der API-Key konnte nicht gelöscht werden",
            });
          } else {
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "API-Key gelöscht",
              message: "Der API-Key wurde erfolgreich gelöscht",
            });
            router.push(`/administration/${this.accordionIndex}`);
          }
        }
      });
    },

    formatDate(dateString) {
      if (!dateString) return 'Nie';
      const date = new Date(dateString);
      return date.toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  watch: {
    '$route.params.apiKeyId': function (newId, oldId) {
      this.apiKeyId = newId;
      this.loadApiKey();
    },
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.apiKeyId = this.$route.params.apiKeyId;
    this.accordionIndex = this.$route.params.accordionIndex;
    if (this.apiKeyId) {
      this.loadApiKey();
    }
  }
};
</script>